import { c as _c } from "react/compiler-runtime";
import { IconTextLayout } from "@/app/(main)/(club)/mes-clubs/[id]/components/modal/event/read/header/";
import Icon from "@/components/icon";
import { EventRead } from "@/TS/Interfaces/global_interfaces";
interface EventReadDateProps {
  event: EventRead;
}
export const EventReadDate: React.FC<EventReadDateProps> = t0 => {
  const $ = _c(5);
  const {
    event
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Icon size={23} icon="agenda" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== event.startDate) {
    t2 = new Date(event.startDate || "").toLocaleDateString("fr-FR", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric"
    });
    $[1] = event.startDate;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <IconTextLayout>{t1}<p className="font-bold capitalize">{t2}</p></IconTextLayout>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};